/**
 * features/exams/ExamTools.tsx
 * ------------------------------------------------------------------
 * Exams → Class subject lists: per class, its pupils, the subjects each takes
 * and who teaches them — the list the office checks entries against.
 *
 * This was LKC's whole exam screen (class subjects, registers, seating) until
 * Al-Nur's exams module came across on 30 Oct 2026. Its registers and seating
 * plans were replaced by Al-Nur's (Exams → Registers, Rooms & seating), which
 * run from a published series; the class subject list has no counterpart
 * there, so it stays.
 * ------------------------------------------------------------------
 */
import { Table } from 'lucide-react';
import { GradientHero } from '@/features/finance/ui';
import ClassSubjectsTab from './ClassSubjectsTab';

export default function ExamTools({ year, term }: { year: string; term: string }) {
  return (
    <div className="space-y-6">
      <GradientHero
        icon={Table}
        title="Class subject lists"
        subtitle={`${term.replace('Term', 'Term ')} ${year} · each class's pupils, their subjects and their teachers`}
      />
      <ClassSubjectsTab />
    </div>
  );
}
